module.exports = __webpack_public_path__ + "f1c84f841857c6d23592f9e69da76e43.MP3";